/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppAuthGuardService } from 'app/core/security/guards/app-auth-guard.service';
import { LayoutComponent } from 'app/layout/layout-component/layout.component';
import { LaunchComponent } from '../components/launch/launch.component';
import { WelcomeComponent } from '../components/welcome/welcome.component';

const routes: Routes = [
	{
		path: '',
		redirectTo: '/launch',
		pathMatch: 'full',
	},
	// {
	//   path: 'print-it',
	//   component: PrintLayoutComponent
	// },
	{
		path: '',
		runGuardsAndResolvers: 'always',
		component: LayoutComponent,
		canActivate: [AppAuthGuardService],
		children: [
			{
				path: 'launch',
				component: LaunchComponent,
			},
			{
				path: 'dashboard',
				loadChildren: () => import('../../modules/ticket/ticket-search/ticket-search.module').then((m) => m.TicketSearchModule), data: { mode: 'dashboard' }
			},
			{
				path: 'welcome',
				component: WelcomeComponent,
			},
			{
				path: 'configuration',
				loadChildren: () => import('../../modules/configuration/configuration.module').then((m) => m.ConfigurationModule),
			},
			{
				path: 'design',
				loadChildren: () => import('../../modules/design/design.module').then((m) => m.DesignModule),
			},
			{
				path: 'events',
				loadChildren: () => import('../../modules/event/event.module').then((m) => m.EventModule),
			},
			{
				path: 'orders',
				loadChildren: () => import('../../modules/order/order-search/order-search.module').then((m) => m.OrderSearchModule),
			},
			{
				path: 'customers',
				loadChildren: () => import('../../modules/customer/customer-search/customer-search.module').then((m) => m.CustomerSearchModule),
			},
			{
				path: 'tickets',
				loadChildren: () => import('../../modules/ticket/ticket-search/ticket-search.module').then((m) => m.TicketSearchModule), data: { mode: 'tickets' }
			},
			{
				path: 'sandbox',
				loadChildren: () => import('../../modules/sandbox/sandbox.module').then((m) => m.SandboxModule),
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	declarations: [],
	exports: [RouterModule],
})
export class LayoutRoutesModule {}
